"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSendBoxStyle;

function createSendBoxStyle(_ref) {
  var sendBoxBackground = _ref.sendBoxBackground,
      sendBoxHeight = _ref.sendBoxHeight,
      sendBoxBorderBottom = _ref.sendBoxBorderBottom,
      sendBoxBorderLeft = _ref.sendBoxBorderLeft,
      sendBoxBorderRight = _ref.sendBoxBorderRight,
      sendBoxBorderTop = _ref.sendBoxBorderTop;
  return {
    '& > .main': {
      alignItems: 'stretch',
      backgroundColor: sendBoxBackground,
      borderBottom: sendBoxBorderBottom,
      borderLeft: sendBoxBorderLeft,
      borderRight: sendBoxBorderRight,
      borderTop: sendBoxBorderTop,
      minHeight: sendBoxHeight
    }
  };
}